import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Welcome from './components/Welcome';
import ComicsPage from './components/Comics';
import ComicDetail from './components/ComicDetail';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/comics" element={<ComicsPage />} />
        <Route path="/:comicName" element={<ComicDetail />} />
      </Routes>
    </Router>
  );
}

export default App;

